import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import {epakRoleGuard} from "../../shared/authguards/epak-role.guard";
import {ContactInfoDeepLinkGuard} from "src/app/shared/authguards/contact-info-deep-link.guard";

export const SETTINGS_ROUTES: Routes = [
  {
    path: "user-profile",
    loadComponent: () => import("./user-profile/user-profile.component").then(m => m.UserProfileComponent),
    canActivate: [AuthGuard],
    canDeactivate: [ContactInfoDeepLinkGuard],
    data: { title: "pageTitles.userProfile" },
  },
  {
    path: "contact-info",
    loadComponent: () => import("./user-profile/user-profile.component").then(m => m.UserProfileComponent),
    canActivate: [AuthGuard],
    canDeactivate: [ContactInfoDeepLinkGuard],
    data: { title: "pageTitles.contactInfo" },
  },
  {
    path: "my-diseases",
    loadComponent: () => import("./my-diseases/my-diseases.component").then(m => m.MyDiseasesComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.myDiseases" },
  },
  {
    path: "my-doctor",
    loadComponent: () => import("./my-doctor/my-doctor.component").then(m => m.MyDoctorComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.myDoctor" },
  },
  // Fitbit integration disabled (EPAK-2253)
  // {
  //   path: "my-apps",
  //   loadComponent: () => import("./my-apps/my-apps.component").then(m => m.MyAppsComponent),
  //   canActivate: [AuthGuard, epakRoleGuard],
  //   data: { title: "pageTitles.myApps" },
  // },
  {
    path: "contact",
    loadComponent: () => import("./contact/contact.component").then(m => m.ContactComponent),
    canActivate: [AuthGuard],
    data: { title: "pageTitles.technicalFeedback" },
  },
  {
    path: "consents",
    loadComponent: () => import("./my-consents/my-consents.component").then(m => m.MyConsentsComponent),
    canActivate: [AuthGuard],
    data: { title: "pageTitles.consents" },
  },
];
